import { useContext } from 'react';
import { PpiAnalysisContext } from '../contexts/PpiAnalysisContext';

export const usePpiAnalysis = () => {
  const context = useContext(PpiAnalysisContext);
  if (!context) {
    throw new Error('usePpiAnalysis must be used within a PpiAnalysisProvider');
  }
  return context;
};